<template>
<!-- 创建工单 -->
  <div class="content">
    <!-- 步骤条 -->
    <div class="steps">
      <div class="step" :class='{ active: number == 0}' @click="change(0)"><div>1</div>选择问题所属产品<span>></span></div>
      <div class="step" :class='{ active: number == 1}' @click="change(1)"><div>2</div>选怎问题类型<span>></span></div>
      <div class="step" :class='{ active: number == 2}' @click="change(2)"><div>3</div>创建工单</div>
    </div>
    <!-- 内容 -->
    <div class="items">
      <!-- item 1 -->
      <div class="item" v-show="number==0">
        <span class="item_title">创建工单</span>
        <el-input v-model="searchValue" placeholder="请输入产品服务关键词" size="small" style="width:250px">
          <template #suffix>
              <i class="el-input__icon el-icon-search" @click="search"></i>
          </template>
        </el-input>
        <!-- selection -->
        <div class="selection" v-for="(item,index) in firstStepList" :key="index">
          <div class="sel_title">{{item.name}}<span>|</span></div>
          <div class="sel_con">
            <div class="sel_item" v-for="(value,i) in item.children" :key="i" @click="choiceFirst(value)">
              {{value.name}}
            </div>
          </div>
        </div>
      </div>
      <!-- item 2 -->
      <div class="item" v-show="number==1">
        <span class="item_title">创建工单</span>
        <!-- selection -->
        <div class="selection">
          <div class="sel_title">问题类型<span>|</span></div>
          <div class="sel_con">
            <div class="sel_item second" v-for="(item,index) in secondStepList" :key="index" @click="choiceSecond(item)">
              {{item.name}}
            </div>
          </div>
        </div>
        <div class="selection">
          <div class="sel_title">热门问答推荐<span>|</span></div>
          <div class="sel_con">
            <div class="sel_box">
              <div class="selbox_item">1、申请开具发票的方法</div>
              <div class="selbox_item">2. 增值税专用发票认证</div>
              <div class="selbox_item">3. 产品购买与支付方法</div>
              <div class="selbox_item">4. 订单有效期</div>
            </div>
          </div>
        </div>
      </div>
      <!-- item 3 -->
      <div class="item" v-show="number==2">
        <span class="item_title">创建工单</span>
        <div class="form">
          <el-form :model="workOrderForm" :rules="rules" ref="workOrderForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="问题类型：">
              <div class="problem_types">
                <span>{{firstStepName}}</span>
                <i>></i>
                <span>{{secondStepName}}</span>
              </div>
            </el-form-item>
            <el-form-item label="工单标题：">
              <el-input size="small" v-model="workOrderForm.title" placeholder="标题长度限制为60个字"></el-input>
            </el-form-item>
            <el-form-item label="问题描述：" prop="description">
              <el-input rows="6" type="textarea" v-model="workOrderForm.description" placeholder="请输入内容"></el-input>
              <el-upload
                class="upload-demo"
                action="string" 
                :http-request="uploadImg"
                :limit="1">
                <el-button class="upload_btn" size="small" plain icon="el-icon-upload">点击上传</el-button>
                <div slot="tip" class="el-upload__tip">
                  <div class="tips">个数及大小限制：1个附件，大小不超过10M</div>
                  <div class="tips">支持格式：zip、rar、doc、docx、xls、pdf、txt、jpg、jpeg、png</div>
                </div>
              </el-upload>
            </el-form-item>
            <el-form-item label="手机号码：" prop="phone">
              <el-input size="small" v-model="workOrderForm.phone" placeholder="请输入手机号码"></el-input>
              <div class="tips">紧急情况时，索道云工程师会与您电话联系，请填写正确手机号</div>
            </el-form-item>
            <!-- <el-form-item label="手机短信提醒：">
              <el-radio-group v-model="workOrderForm.phone">
                <el-radio label="任何时间"></el-radio>
                <el-radio label="每日9:00-18:00"></el-radio>
                <el-radio label="不提醒"></el-radio>
              </el-radio-group>
            </el-form-item> -->
            <el-form-item label="电子邮箱：" prop="email">
              <el-input size="small" v-model="workOrderForm.email" placeholder="请输入电子邮箱"></el-input>
            </el-form-item>
            <el-form-item label="">
              <div class="submit_btn"  @click="submitForm">提交</div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { queryAllTicketCategory, queryQuestionTypeByTicketCategoryId, addTicket } from '@/api/console/supportServices.js'
import token from '@/utils/token.js'
import { obsUploadFile } from '@/api/resource.js'
export default {
  data() {
    return {
      number: 0,
      searchValue: '',
      firstStepList: [],
      firstStepId: null,
      firstStepName: '',
      //second step
      secondStepList: [],
      secondStepId: null,
      secondStepName: '',
      // third step
      workOrderForm: {
        title: '',
        description: '',
        fileUrl: '',
        phone: '',
        email: '',
        status: 0
      },
      rules: {
        description: [
          { required: true, message: '请填写问题描述', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请填写手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '手机号码格式不正确', trigger: 'blur' }
        ],
        email: [
            { required: true, message: '请填写邮箱地址', trigger: 'blur' },
			      { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
          ]
      },
      timer: null
    }
  },
  created() {
    this.getData();
  },
  watch: {
    //监听Email输入
    // 'workOrderForm.email': {
    //   deep: true,
    //   handler(newVal, oldVal) {
	  //     // if(newVal.trim().length !== 0) {
    //       this.debounce(this.changeEmail, 900) 
    //     // }
	  //   }
    // }
  },
  methods: {
    async getData() {
      let res = await queryAllTicketCategory();
      let arr = [];
      res.data.list.forEach((e) => {
        if(e.parentId === 0) {
          arr.push({
            ...e,
            key: Date.now(),
            children: [],
          });
        } else {
          arr.forEach((value) => {
            if(e.parentId == value.id) {
              value.children.push({
                ...e,
                key: Date.now()
              })
            }
          })
        }
      });
      this.firstStepList = arr;
    },
    change(i) {
      if (i == 0) {
        this.number = i;
      } else if (i == 1) {
        if(this.firstStepId != null) {
          this.number = i;
        } else {
          return;
        }
      } else {
        if(this.secondStepId != null) {
          this.number = i;
        } else {
          return;
        }
      }
    },
    //搜索
    search() {},
    //选择问题所属产品
    async choiceFirst(data) {
      this.firstStepId = data.id;
      this.firstStepName = data.name;
      let res = await queryQuestionTypeByTicketCategoryId(this.firstStepId);
      this.secondStepList = res.data.list;
      this.change(1);
    },
    //选择问题类型
    choiceSecond(data) {
      this.secondStepId = data.id;
      this.secondStepName = data.name;
      this.change(2);
    },
    //上传附件
    uploadImg(param) {
			let formData = new FormData();
      formData.append("file", param.file);
      obsUploadFile(formData).then(res=> {
        this.workOrderForm.fileUrl = res.data;
      })
    },
    //防抖
    debounce(fn, wait) {
	    if (this.timer !== null) {
	      clearTimeout(this.timer)
	    }
	    this.timer = setTimeout(fn, wait)
	  },
    //email输入框触发
    // changeEmail() {
    //   this.$refs['workOrderForm'].validate((valid) => {
    //     if (valid) {
    //       this.submitBtnUsable = true;
    //     } else {
    //       return false;
    //     }
    //   })
    // },
    //提交表单
    submitForm() {
      this.$refs['workOrderForm'].validate((valid) => {
        if(valid) {
          let param = {
            ...this.workOrderForm,
            ticketCategoryId: this.firstStepId,
            questionTypeId: this.secondStepId,
            userId: token.getUser().id
          };
          addTicket(param).then(()=> {
            this.$message.success('提交成功!');
            //提交成功后清空数据
            this.firstStepId = null;
            this.secondStepId = null;
            this.workOrderForm = {
              title: '',
              description: '',
              fileUrl: '',
              phone: '',
              email: '',
              status: 0
            },
            this.change(0);
            // this.$router.push({path: '/supportServices',query:{ index: 1 }});
          })
        } else {
          return false;
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped="scoped">
.content {
  .steps {
    display: flex;
    align-items: center;
    height: 60px;
    .step {
      display: flex;
      align-items: center;
      height: 50px;
      margin-right: 20px;
      font-size: 14px;
      color: #AAA;
      div {
        width: 25px;
        height: 25px;
        margin-right: 10px;
        border-radius: 50%;
        background-color: #AAA;
        font-size: 13px;
        color: #fff;
        text-align: center;
        line-height: 25px;
      }
      span {
        margin-left: 20px;
        font-size: 20px;
      }
    }
    .step:hover {
      cursor: pointer;
    }
    .active {
      color: #5984EC;
      div {
        background-color: #5984EC;
      }
    }
  }
  .items {
    padding: 20px;
    border: 1px solid #E5E5E5;
    .item {
      .item_title {
        color: #4F4F4F;
      }
      .el-input {
        float: right;
      }
      .selection {
        margin-top: 20px;
        .sel_title {
          width: 90px;
          font-size: 12px;
          color: #6C6C6C;
          span {
            margin-left: 10px;
            font-size: 14px;
            font-weight: 700;
            color: #537EEE;
          }
        }
        .sel_con {
          display: flex;
          margin-left: 80px;
          .sel_item {
            width: 20%;
            height: 30px;
            margin: 10px 10px 0 0;
            border: 1px solid #E5E5E5;
            font-size: 14px;
            color: #6C6C6C;
            text-align: center;
            line-height: 30px;
          }
          .sel_item:hover {
            cursor: pointer;
            border-color: #537EEE;
            color: #537EEE;
          }
          .second {
            width: 35%;
          }
          .sel_box {
            overflow: hidden;
            width: 70%;
            padding: 20px;
            margin-top: 20px;
            border: 1px solid #E5E5E5;
            font-size: 12px;
            color: #6C6C6C;
            .selbox_item {
              float: left;
              width: 33%;
              margin-bottom: 10px;
            }
            .selbox_item:hover {
              cursor: pointer;
              color: #5984EC;
              text-decoration: underline;
            }
          }
        }
      }
      .form {
        width: 50%;
        margin-top: 20px;
        // /deep/ .el-form-item__content {
        //   line-height: 20px;
        // }
        .problem_types {
          font-size: 12px;
          color: #5783EE;
          i {
            margin: 0 10px;
          }
        }
        .upload_btn {
          margin-top: 20px;
        }
        .tips {
          font-size: 12px;
          color: #AAA;
          line-height: 20px;
        }
        .submit_btn {
          width: 157px;
          height: 32px;
          margin-top: 20px;
          background-color: #5984EC;
          font-size: 12px;
          color: #fff;
          text-align: center;
          line-height: 32px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>